"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaticDataPublic = exports.getStaticData = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
/**
 * Get static data from the authenticated endpoint
 * Requires authentication token
 * @returns {Promise} Static data object
 */
function getStaticData() {
    return api_1.default.get('/api/static-data').then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getStaticData = getStaticData;
/**
 * Get static data from the public endpoint
 * Does not require authentication, but can work with or without token
 * @returns {Promise} Static data object (filtered subset)
 */
function getStaticDataPublic() {
    return api_1.default.get('/api/static-data-extern').then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getStaticDataPublic = getStaticDataPublic;
var staticDataApi = {
    getStaticData: getStaticData,
    getStaticDataPublic: getStaticDataPublic,
};
exports.default = staticDataApi;
